import PoweredByPropellerLogo from "../../images/powered-by-propeller.svg";
import IcSecurity from "../../images/ic-security.svg";

export default function Footer() {
  return (
    <footer className="bg-surface-section px-l py-2xl text-text-contrast-secondary">
      <div className="lg:flex lg:items-center lg:w-full lg:max-w-container lg:mx-auto">
        <img
          src={PoweredByPropellerLogo}
          alt="Powered by Propeller logo"
          width="146"
          height="36"
        />
        <div className="flex flex-col gap-m mt-2xl pt-l border-t border-separator-light lg:flex-1 lg:flex-row lg:justify-between lg:mt-0">
          <p className="body-m text-text-contrast-secondary">
            &copy; {new Date().getFullYear()} Propeller | All rights reserved.
          </p>
          <div className="flex items-center gap-s">
            <a
              href="https://getonpropeller.com/terms.html"
              className="body-m text-text-contrast-secondary hover:underline"
            >
              Terms and Conditions
            </a>
            <span className="body-m text-text-contrast-secondary">|</span>
            <a
              href="https://getonpropeller.com/terms.html#consumer-data-privacy-policy"
              className="flex items-center gap-s body-m text-text-contrast-secondary hover:underline"
            >
              <img
                src={IcSecurity}
                alt="Privacy Policy"
                width="16"
                height="16"
              />
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
